import React, { useEffect, useMemo, useState } from 'react';
import {
  type MRT_ColumnFiltersState,
  type MRT_PaginationState,
  type MRT_SortingState,
  type MRT_ColumnDef,
  useMaterialReactTable,
  MaterialReactTable,
} from 'material-react-table';
import { Box } from '@mui/material';
import {VersOreDTO} from "../gestversore/types";
import {useGetVersOreByProgNodo} from './Services';

interface Props {
  codprogprop: string;
  codnodoprop: string;
}

const ListaMonitorProgettiVersOreInline: React.FC<Props> = ({ codprogprop,codnodoprop }) => {
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 100,
  });

  useEffect(() => {
    if (codprogprop) {
      setColumnFilters([{ id: 'CODPROG', value: codprogprop }]);
    }
  }, [codprogprop]);

const {
  data: { results = [], count = 0 } = {},
  isError,
  isFetching,
  isLoading,
} = useGetVersOreByProgNodo(codprogprop, codnodoprop);

const renderNumberWithHighlight = (rawValue?: string | number | null) => {
  if (rawValue === null || rawValue === undefined) {
    return (
      <div style={{ textAlign: 'right' }}>
        0
      </div>
    );
  }

  const normalized =
    typeof rawValue === 'number'
      ? rawValue
      : parseFloat(rawValue.replace(',', '.'));

  return (
    <div
      style={{
        backgroundColor: normalized < 0 ? '#ffe5e5' : 'transparent',
        padding: '2px 4px',
        borderRadius: '4px',
        textAlign: 'right',
      }}
    >
      {rawValue}
    </div>
  );
};

const columns = useMemo<MRT_ColumnDef<VersOreDTO>[]>(() => [
  { accessorKey: 'nrrel', header: 'NrRel', size: 2, enableEditing: false, },
  // { accessorKey: 'variante', header: 'NrRelOrig', size: 2, enableEditing: false, },
  // { accessorKey: 'desditta', header: 'Ditta', size: 2, enableEditing: false, },
  { accessorKey: 'coddip', header: 'Dip', size: 2, enableEditing: false, },
  {
      accessorKey: 'datareg',
      header: 'Data',
      size: 2,
      filterVariant: 'date-range',
      Cell: ({ cell }) => {
        const value = cell.getValue<string>();
        if (!value) return '';

        return new Date(value).toLocaleDateString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
        });
      },
    },
  // { accessorKey: 'desprog', header: 'Progetto', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },
  // { accessorKey: 'desnodo', header: 'Nodo', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 10 ? `${value.substring(0, 10)}...` : value}</span> ); }, },
  { accessorKey: 'desatt', header: 'Attivita', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 10 ? `${value.substring(0, 10)}...` : value}</span> ); }, },
  { accessorKey: 'note', header: 'Note', size: 2, enableEditing: false,  Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 80 ? `${value.substring(0, 80)}...` : value}</span> ); }, },
  { accessorKey: 'opzione', header: 'Opzione', size: 2, enableEditing: false,},
  { accessorKey: 'oremin', header: 'Ore', size: 2, enableEditing: false,},
  { accessorKey: 'luogo', header: 'Luogo', size: 2, enableEditing: false,},
], []);

  const table = useMaterialReactTable({
    columns,
    data: results,
    rowCount: count,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableColumnActions: false,
    enableSorting: false,
    enablePagination: false,
    muiTableProps: {
  sx: {
    '& .MuiTableCell-root': {
      padding: '2px 6px',
      fontSize: '0.75rem',
    },
  },
},
muiTableBodyRowProps: {
  sx: { height: '28px' },
},
muiTableHeadRowProps: {
  sx: { height: '30px' },
},

    // muiTableBodyCellProps: { sx: { padding: '4px', fontSize: '0.75rem' } },
    // muiTableHeadCellProps: { sx: { padding: '4px', fontSize: '0.75rem' } },
    state: {
      isLoading,
      showProgressBars: isFetching,
      showAlertBanner: isError,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
  });

return (
      <MaterialReactTable table={table} />


);

};

export default ListaMonitorProgettiVersOreInline;
